import { noop } from 'lodash-es';
import { useMemo } from 'react';
import Result, { getStoreCount, ResultProps } from './Result';
import { FV, Store } from './share';
import StoreScopesForm from './StoreScopesForm';

export interface StoreScopesPreviewProps extends ResultProps {
  value: General.StoreScope[];
  storeMap?: Partial<Record<number, Store>>;
}

function StoreScopesPreview(props: StoreScopesPreviewProps) {
  const { value, storeMap, ...otherProps } = props;

  const initialValues = useMemo<FV>(() => {
    return {
      mode: 'platform',
      storeScopes: value.filter((platformScope) => getStoreCount([platformScope])),
      assets: {
        storeMap: storeMap || {},
        wabaMap: {},
      },
    };
  }, [value, storeMap]);

  return (
    <StoreScopesForm initialValues={initialValues} onSubmit={noop}>
      {() => <Result editable={false} {...otherProps} />}
    </StoreScopesForm>
  );
}

export default StoreScopesPreview;
